<template>
  <div class="social-share vc share-component">
    <a class="social-share-icon icon-wechat" href="javascript:">
      <div class="wechat-qrcode"><h4>微信扫一扫：分享</h4>
        <div id="qrcode"></div> <!-- 创建一个div，并设置id为qrcode -->
        <div class="help">
          <p>微信里点“发现”，扫一扫</p>
          <p>便可将本文分享至朋友圈。</p>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'  // 引入qrcode
export default {
  props:['title','url'],
  data () {
      return {
        isShow:false,
      }
  },
  mounted () {
    this.isShow=this.url?true:false
    this.qrcode();
  },
  methods: {
    qrcode() {
      let qrcode = new QRCode('qrcode', {
        width: 110,
        height: 110,
        text: this.url||location.href, // 二维码地址
        colorDark : "#000",
        colorLight : "#fff",
      })
    },
    cancel(){
      this.$emit('fun',"");
      this.isShow=false;
    }
  }
}
</script>
<style scoped>

  #qrcode{display: inline-block;margin-top: 5px;}

</style>



// WEBPACK FOOTER //
// src/components/code.vue